<template>
  <div class="flex mb-4">
    <div class="w-full sm:w-1/2 md:w-1/4 lg:w-1/4 xl:w-1/4 px-2" v-for="item of data" :key="item.id">
      <statistics-card
        class="mb-base"
        :icon="item.icon"
        :title="$i18n.locale === 'us' ? item.name : item.name_esp"
        :statistic="item.total"
        :color="item.color"
        @click="handleClick(item.id)"
      />
    </div>
  </div>
</template>
<script>
import StatisticsCard from '@/views/components/StatisticsCard.vue'
export default {
  props:{
    data:{
      type:Array,
      default:() => []
    }
  },
  components:{
    StatisticsCard
  },
  methods:{
    handleClick(id){
      this.$emit('click',id)
    }
  },
}
</script>
